import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApplicationDto } from '../../models/application.model';
import { ConfigService } from 'src/app/core/services/config-service';
import { EnvironmentType } from '../../models/enums/environment-type';

@Injectable({
  providedIn: 'root',
})
export class FormsService {
  constructor(private http: HttpClient) {}

  configService = inject(ConfigService);

  loadFormByUuid(uuid: string, env?: string): Observable<ApplicationDto> {
    if (!env) {
      env = EnvironmentType.Config;
    }
    const url =
      this.configService.readConfig().baseUrlInfrastructure +
      `/Application/LoadByUuidAndEnv` +
      `?uuid=${uuid}&env=${env}`;
    return this.http.get<ApplicationDto>(url);
  }

  loadFormByUuidPublic(uuid: string, env?: string): Observable<ApplicationDto> {
    if (!env) {
      env = EnvironmentType.Config;
    }
    const url =
      this.configService.readConfig().baseUrlBusiness +
      `/Application/LoadByUuidAndEnv` +
      `?uuid=${uuid}&env=${env}`;
    return this.http.get<ApplicationDto>(url);
  }

  publish(
    applicationUuid: string,
    envTo: EnvironmentType
  ): Observable<ApplicationDto> {
    const url =
      this.configService.readConfig().baseUrlInfrastructure +
      `/Application/Publish` +
      `?uuid=${applicationUuid}&envFrom=${EnvironmentType.Config}&envTo=${envTo}`;
    return this.http.get<ApplicationDto>(url);
  }

  getVersion(
    applicationUuid: string,
    env?: EnvironmentType
  ): Observable<ApplicationDto> {
    const url =
      this.configService.readConfig().baseUrlInfrastructure +
      `/application/LoadByUuidAndEnv` +
      `?uuid=${applicationUuid}&env=${env}`;
    return this.http.get<ApplicationDto>(url);
  }
}
